<template>
    <section>
        <h4>Let's get started</h4>
        <p>Select the Fixed LTE provider you signed up for</p>
        <div class="selector-cards">
            <selector-card
                icon="pure-lte"
                label="(MTN)"
                :isSelected="provider === 'pure-lte'"
                @select="select('pure-lte')">
            </selector-card>
            <selector-card
                icon="telkom-lte"
                :isSelected="provider === 'telkom-lte'"
                @select="select('telkom-lte')">
            </selector-card>
        </div><!-- end.selector-box -->
        <section-footer
            :buttons="buttons"
            @next="next()"
            @back="back()">
        </section-footer>
    </section>
</template>

<script>
    import SelectorCard from '@/components/SelectorCard'
    import SectionFooter from '@/components/SectionFooter'

    export default {
        components: {
            SelectorCard,
            SectionFooter,
        },
        computed: {
            provider() {
                return this.$store.getters['provider'];
            },
            buttons() {
                return [
                    {
                        label: 'Back',
                        event: 'back',
                        class: 'ghost',
                        disabled: true
                    },
                    {
                        label: 'Next',
                        event: 'next',
                        class: '',
                        disabled: !this.provider
                    }
                ]
            }
        },
        data() {
            return {

            }
        },
        methods: {
            select(provider) {
                this.$store.commit('updateProvider', provider);
            },
            next() {
                this.$router.push({name: 'hardware'});
            },
            back() {
                return false;
            },
        }
    }
</script>
